var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"buttons-group\">\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/view_mode/workflow.hbs
// module id = 148
// module chunks = 0